import { Card, Typography, Stack, CardContent, Divider, CardHeader } from "@mui/material";
import React from "react";

export default function BiggestOpportunities(props: { biggest_opportunities: any }) {
    const { biggest_opportunities } = props;
    return (
        <React.Fragment>
            {biggest_opportunities && biggest_opportunities.length > 0 ? (
            <Card sx={{
                maxHeight: 370, height: '100%', 
                borderRadius: 2, 
                border: 0,
                boxShadow: 'none',
                // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}>
                <CardHeader title="Top 5 Opportunities"  slotProps={{ title: { sx: { fontSize: '1.2rem !important' } } }} />
                <Divider />
                <CardContent>
                    <Stack direction="column" spacing={2} sx={{ width: '100%', height: 300, overflowY: 'auto' }}>
                        {biggest_opportunities.length > 0 && biggest_opportunities.map((opportunity: any, index: number) => (
                            <Typography sx={{ fontSize: '1rem !important' }} key={index}>{opportunity}</Typography>
                        ))}
                    </Stack>
                </CardContent>
            </Card>
        ) : (
            <Card sx={{
                maxHeight: 300, height: 'auto', 
                borderRadius: 2, 
                border: 0,
                boxShadow: 'none',
                // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}>
                <CardHeader title="Biggest Opportunities"  slotProps={{ title: { sx: { fontSize: '1.2rem !important' } } }} />
                <Divider />
                <CardContent>
                    <Typography variant="h5" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
                </CardContent>
            </Card>
        )}
        </React.Fragment>
    );
}